import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { GlobalStoreService } from '../services/global-store.service';

import { environment } from '@environments/environment';
import { injectAuthFeature } from '@mymill/core/auth';

@Injectable({
  providedIn: 'root',
})
export class AppGuard {
  private readonly authFeature = injectAuthFeature();
  private readonly globalStoreService = inject(GlobalStoreService);

  /**
   * constructor
   *
   */
  constructor(
    private router: Router,
    //private authStoreService: AuthStoreService,
  ) {}

  /**
   * canActivate
   *
   */
  public canActivate(
    route: ActivatedRouteSnapshot,
    routeState: RouterStateSnapshot,
  ): boolean {
    const allowedApps = environment.core.allowedApps;

    if (allowedApps.find((allowedApp) => route.data.app.includes(allowedApp))) {
      return true;
    }

    //this.globalStoreService.initBeforeLogout();
    this.authFeature.logout(true);
    //this.authStoreService.logout(true);
    this.router.navigate(['/error']).catch();

    return false;
  }
}
